import { useContext, lazy, Suspense } from 'react';
import { GlobalContext } from '../context/GlobalContext';

import Notify from './Notify/Notify';
import FTTHOTP from './FTTHOTP/FTTHOTP';
import Loading from '../components/Loading/Loading';
import FTTHSuccess from './FTTHSuccess/FTTHSuccess';
import ErrorModal from '../components/ErrorModal/ErrorModal';
import CoverageCheck from '../components/CoverageCheck/CoverageCheck';

import './Pages.scss';
import { useTranslation } from 'react-i18next';
import InfoModal from '../components/InfoModal/InfoModal';

const Home = lazy(() => import('./Home/Home'));

function Pages() {
    const { state, dispatch }: any = useContext(GlobalContext);
    const { loading, rtl, gisZone, page, coverageLoading } = state;
    const { t } = useTranslation();
    const coveredFiber = gisZone?.Data?.Coveredfiber === 'true' ? true : false; 
    const FTTHZoneCoverage = gisZone?.Data?.FTTHZoneCoverage === 'true' ? true : false; 
    const handleHeaderCancel = () => {
        console.log('cancel')
    }

    const modalSecondButtonClick = () => {
        dispatch({ type: 'UPDATE_PAGE', payload: 'map' })
    }

    const modalFirstButtonClick = () => {
        dispatch({ type: 'UPDATE_GIS_ZONE', payload: {} })
    }

    return (
        <div className='container FTTH__Pages'>
            {page === 'map' && <Suspense fallback={<Loading loading={true} />}>
                <Home />
            </Suspense>}
            {page === 'notify' && <Notify
                handleHeaderCancel={handleHeaderCancel}
            />}

            {page === 'otp' && <FTTHOTP
                handleHeaderCancel={handleHeaderCancel}
            />}

            {page === 'success' && <FTTHSuccess />}
            {loading && <Loading
                loading={loading}
            />}
            {(coverageLoading || (gisZone?.Data  && !FTTHZoneCoverage)) && <CoverageCheck
                id={''}
                rtl={rtl}
                loader={coverageLoading}
                description='Coverage check in progress...'
                modalFirstButtonClick={modalFirstButtonClick}
            />}
            {coveredFiber && FTTHZoneCoverage && <InfoModal
                id={''}
                rtl={rtl}
                data={{ODB: gisZone?.Data?.ODB}}
                modalFirstButtonClick={modalFirstButtonClick}
            />}

            {page === 'error' && (
                <ErrorModal
                    id={'not-a-mobily-number'}
                    rtl={rtl}
                    title={t('Wrong')}
                    description={t('Request_Wrong')}
                    firstButtonText={t('Got_it')}
                    modalFirstButtonClick={modalSecondButtonClick}
                />
            )}
        </div>
    )
}

export default Pages